import { ReactNode, useEffect, useRef } from 'react'
import { useAuth } from 'react-oidc-context'
import { useLocation } from 'react-router-dom'
import { setAuthToken, setCurrentUserId } from '../../api/client'
import { savePostLoginRedirectPath } from './utils.ts'
type Props = {
  children: ReactNode
}
export function AuthGate({ children }: Props) {
  const {
    isLoading,
    isAuthenticated,
    signinRedirect,
    error,
    activeNavigator,
    user
  } = useAuth()
  const hasTriggeredLogin = useRef(false)
  const location = useLocation()

  useEffect(() => {
    if (
      !isLoading &&
      !isAuthenticated &&
      !error &&
      activeNavigator === undefined &&
      !hasTriggeredLogin.current
    ) {
      hasTriggeredLogin.current = true
      if (!location.pathname.startsWith('/auth')) {
        const pathForRedirect = `${location.pathname}${location.search}${location.hash}`
        savePostLoginRedirectPath(pathForRedirect || '/')
      }
      signinRedirect().catch(signinError => {
        console.error('Failed to start OIDC sign-in redirect', signinError)
      })
    }
  }, [
    isLoading,
    isAuthenticated,
    error,
    activeNavigator,
    signinRedirect,
    location.pathname,
    location.search,
    location.hash
  ])

  useEffect(() => {
    setAuthToken(user?.access_token ?? null)
    const userId =
      (user?.profile?.sub as string | undefined) ??
      (user?.profile as { id?: string } | undefined)?.id ??
      null
    setCurrentUserId(userId)
  }, [user])

  if (isLoading || activeNavigator === 'signinRedirect') {
    return <div>Авторизация...</div>
  }

  if (error) {
    return (
      <div>
        Не удалось авторизоваться.{' '}
        <button type="button" onClick={() => signinRedirect()}>
          Попробовать снова
        </button>
      </div>
    )
  }
  if (!isAuthenticated) {
    return <div>Перенаправление на страницу входа...</div>
  }
  return <>{children}</>
}
